import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Card, CardContent, Popover } from "@mui/material";
import Fire from "../assets/svg/Fire.svg";
import Engineering from "../assets/svg/Engineering.svg";
import Health from "../assets/svg/Health.svg";
import Liability from "../assets/svg/Liability.svg";
import Life from "../assets/svg/Life.svg";
import Marine from "../assets/svg/Marine.svg";
import Misc from "../assets/svg/Misc.svg";
import Motor from "../assets/svg/Motor.svg";
import Package from "../assets/svg/Package.svg";
import ProductsForm from "./ProductsForm";
import Backdrop from "@mui/material/Backdrop";
import ColorsJson from "../../src/theme/colors.json";

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: "pointer",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    borderRadius: "10px",
  },
  media: {
    height: 70,
    width: "60px",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: "1rem",
  },
  item: {
    flex: "0 0 15%",
    justifyContent: "center",
    alignItems: "center",
  },
  cardTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  selected: {
    borderRadius: "0.625rem",
    cursor: "pointer",
    background: ColorsJson.WHITE_BACKGROUND,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0.5rem",
    fontSize: theme.fontSizes.SMALL,
  },
  clickSelected: {
    borderRadius: "0.625rem 0.625rem 0 0",
    cursor: "pointer",
    background: ColorsJson.WHITE_BACKGROUND,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0.5rem",
    fontSize: theme.fontSizes.SMALL,
  },
  notSelected: {
    opacity: 0.5,
    borderRadius: "0.625rem",
    cursor: "pointer",
    background: ColorsJson.WHITE_BACKGROUND,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0.5rem",
    fontSize: theme.fontSizes.SMALL,
  },
  categorySection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.fontSizes.LARGE,
    // justifyContent: "space-around",
  },
  popOverStyles: {
    boxShadow: "none",
  },
}));

const ProductCard = ({
  option,
  onSelect,
  anchorEl,
  setAnchorEl,
  selectedOption,
  setSelectedOption,
}) => {
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setSelectedOption(option);
    onSelect({ name: "productCategory", value: option });
  };

  const images = {
    Fire,
    Engineering,
    Health,
    Liability,
    Life,
    Marine,
    Misc,
    Motor,
    Package,
  };

  return (
    <>
      <div
        className={
          anchorEl
            ? selectedOption === option
              ? classes.clickSelected
              : classes.notSelected
            : classes.selected
        }
        onClick={handleClick}
      >
        <div className={classes.categorySection}>
          <img src={images[option]} alt={option} className={classes.media} />
          <div className={classes.cardTitle}>{option}</div>
        </div>
      </div>
    </>
  );
};

const CategoryCards = ({
  options,
  onSelect,
  productCategory,
  productCodes,
  handleProductCodeChange,
  setProductCodes,
}) => {
  const classes = useStyles();

  const [selectedOption, setSelectedOption] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedOption("");
    setProductCodes([]);
  };

  return (
    <div className={classes.container}>
      {options.map((option, index) => (
        <div key={index} className={classes.item}>
          <ProductCard
            option={option}
            onSelect={onSelect}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        </div>
      ))}
      {productCodes && productCodes.length > 0 && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          PaperProps={{ className: classes.popOverStyles }} // Remove box shadow
        >
          <ProductsForm
            productCodes={productCodes}
            handleProductCodeChange={handleProductCodeChange}
          />
        </Popover>
      )}
    </div>
  );
};

export default CategoryCards;
